import { Injectable } from "@angular/core";
import { FaqInterface } from "src/app/core/interfaces/faq-interface";
import { BackendService } from "src/app/core/services/backend-service";

@Injectable({
  providedIn: "root",
})
export class FaqService extends BackendService {
  getFaqs(): Promise<FaqInterface[]> {
    return this.get<Array<FaqInterface>>(`api/faq`)
      .then((apiItems) => {
        return apiItems;
      })
      .catch((error) => {
        console.warn("Erreur lors de la récupération des FAQs:", error);
        return [];
      });
  }
}
